import { render, staticRenderFns } from "./indexTabs.vue?vue&type=template&id=64e0b36a&scoped=true&lang=pug&"
import script from "./indexTabs.vue?vue&type=script&lang=js&"
export * from "./indexTabs.vue?vue&type=script&lang=js&"
import style0 from "./indexTabs.vue?vue&type=style&index=0&id=64e0b36a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0b36a",
  null
  
)

export default component.exports